import manager from 'app/module46/component-manager.js';
import Swal from 'sweetalert2';
import componentManager from 'app/module46/component-manager.js';

const setupForm = (element) => {
    let page;

    const selectAll = element.querySelector('.add-product-to-event__select-all');
    const perPage = element.querySelector('.add-product-to-event__per-page input[type="hidden"]');
    const prevPage = element.querySelector('.add-product-to-event__prev-page');
    const nextPage = element.querySelector('.add-product-to-event__next-page');
    const pages = element.querySelector('.add-product-to-event__pages');

    const products = element.querySelectorAll('.add-product-to-event__product input[type="checkbox"]');

    componentManager.execute(Swal.getPopup());

    const getContainer = product => product.parentElement.parentElement;

    const getLastPage = () => {
        const whole = Math.floor(products.length / (perPage.value || products.length));
        const remainder = products.length % (perPage.value || products.length);
        return remainder ? whole+1 : whole;
    };

    const render = (newPageNumber) => {
        page = newPageNumber;

        const startIndex = perPage.value ?
            (page-1) * perPage.value
            : 0;
        const endIndex = perPage.value ?
            startIndex + parseInt(perPage.value)
            : products.length;

        // set visibility of list elements
        for (let i = 0; i < products.length; i++) {
            if (i < startIndex || i >= endIndex) {
                getContainer(products[i]).style.display = 'none';
            }
            else {
                getContainer(products[i]).style.removeProperty('display');
            }
        }

        // set pagination links
        pages.innerHTML = '';
        prevPage.style.display = 'none';
        nextPage.style.display = 'none';
        if (perPage.value) {
            for (let i = 1; i <= getLastPage(); i++) {
                let el;
                if (i === page) {
                    el = document.createElement('span');
                }
                else {
                    el = document.createElement('a');
                    el.addEventListener('click', () => render(i));
                }
                el.textContent = i;
                pages.appendChild(el);
            }

            if (page > 1) {
                prevPage.style.removeProperty('display');
            }
            if (page < getLastPage()) {
                nextPage.style.removeProperty('display');
            }
        }
    };

    perPage.addEventListener('change', () => {
        render(1);
    });

    prevPage.addEventListener('click', () => {
        if (page > 1) {
            render(--page);
        }
    });

    nextPage.addEventListener('click', () => {
        if (page < getLastPage()) {
            render(++page);
        }
    });

    selectAll.addEventListener('click', () => {
        products.forEach(product => {
            if (getContainer(product).style.display !== 'none') {
                product.checked = true;
            }
        });
    });

    render(1);
    return products;
};

manager.register('add-product-to-event', (component, elements, attributes, properties) => {
    const {
        title,
        templateUrl,
        submitUrl,
    } = properties;

    let products, template;

    const getSwalConfig = () => ({
        title,
        html: template,
        customClass: {
            confirmButton: 'call-to-action call-to-action--black',
            htmlContainer: 'add-product-to-event',
            container: 'add-product-to-event--modal-container',
            actions: 'add-product-to-event--actions',
        },
        buttonsStyling: false,
        showLoaderOnConfirm: true,
        showCloseButton: true,
        willOpen: element => products = setupForm(element),
        preConfirm: abc => {
            const payload = new FormData();
            products.forEach(product => {
                if (product.checked) {
                    payload.append('selectedProductIds[]', product.value);
                }
            });
            const errorMessageEl = Swal.getHtmlContainer()
                .querySelector('.add-product-to-event__error-message');
            errorMessageEl.textContent = '';

            return new Promise(resolve => {
                manager.api(
                    submitUrl,
                    payload,
                    success => {
                        if (success.errorMessage) {
                            errorMessageEl.textContent = success.errorMessage;
                            resolve(false);
                        }
                        else {
                            resolve(true);
                        }
                    },
                    error => {
                        resolve(false);
                    }
                );
            })
        }
    });

    component.addEventListener('click', () => {
        Swal.showLoading();
        manager.get(templateUrl, success => {
            template = success;
            Swal.fire(getSwalConfig());
        });
    });

});
